import { Get } from "api";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_SUB_COMPANIES,
  fetchSubCompaniesSuccess,
  fetchSubCompaniesFailure,
} from "./action";

function* fetchSubCompanies(action: {
  type: string;
  payload: string | number;
}): Generator<any, void, any> {
  try {
    const response = yield call(
      Get,
      `/manage/partner/${action.payload}/companies`
    );
    yield put(fetchSubCompaniesSuccess(response || []));
  } catch (error) {
    yield put(fetchSubCompaniesFailure(error));
  }
}

export function* subCompaniesSaga() {
  yield takeEvery(FETCH_SUB_COMPANIES, fetchSubCompanies);
}
